// import util from "@tencent/yyb-fe-util";
// var ping = util.http.ping;
var pingSeq = 0;
function ping(url) {
    var img = new Image();
    window[img.id = '__ping' + pingSeq++] = img;
    img.onload = img.onerror = function () {
        window[img.id] = null;
        img.onload = img.onerror = null;
    }
    img.src = url;
}
var cache = [];

var Report = {
    opt: null,
    isDebug: null,
    init: function (opt) {
        this.opt = opt;
        this.isDebug = opt.isDebug;
        this.ReportConf = opt.ReportConfList[opt.name];
        this.ReportConf.sourceScene = opt.sourceScene || "";
        this.ReportConf.sourceSceneSlotId = opt.sourceSceneSlotId || "";
        this.ReportConf.sourceModelType = opt.sourceModelType || "";
        this.ReportConf.via = opt.via || "";
        // 用于直出的时候，读取服务器端的上报数据带过来
        if (window.__report_cache__) {
            cache = window.__report_cache__;
        }
        if (opt.autoReportPv) {
            this.send({
                slotId: '-1',
                action: '100'
            }, {
                noAllowBatchCall: true
            });
        }
    },
    send: function (opt, extOpt) { //处理行为日志
        opt = opt || {};
        extOpt = extOpt || {};
        var reportConf = this.ReportConf || {}, reportData = {};

        //=================一些公用的字段===================
        reportData.isImmediately = 1;
        reportData.scene = opt.scene || reportConf.scene || '';
        reportData.sourceScene = opt.sourceScene || reportConf.sourceScene || '';
        reportData.sourceSceneSlotId = opt.sourceSceneSlotId || reportConf.sourceSceneSlotId || '';
        reportData.sourceModelType = opt.sourceModelType || reportConf.sourceModelType || '';
        reportData.via = opt.via || reportConf.via || '';
        reportData.params = opt.extraData || reportConf.extraData || ""

        //=================自定义上报字段===================
        for (var name in opt) {
            reportData[name] = opt[name];
        }

        //==================上报=====================
        if ((JsBridge.SCENE & JsBridge.SCENE_DOWNLOADER) && JsBridge.report) {
            //端内
            if (extOpt.noAllowBatchCall) {//立即上报
                JsBridge.allowBatchCall = false;
                JsBridge.reportImmediate(reportData);
                JsBridge.allowBatchCall = true;
            } else {
                JsBridge.report(reportData);
            }
        } else {
            //端外
            this.reportOutside(reportData);
        }

        if (typeof __DEBUG__ != "undefined" && __DEBUG__ || this.isDebug) {
            window.__reported__ = window.__reported__ || {};
            window.__reported__[JSON.stringify(reportData)] = true;
            console.log('===========================威武的统计=====================');
            console.log(JSON.stringify(reportData));
        }
    },
    reportOutside: function (data) { //外部上报行为日志
        //组合参数
        var params = {},
            escape = ['slotId', 'status', 'subPosition', 'download'],
            paramsName = ['scene', 'action', 'extraData', 'time', 'sourceScene', 'slot', 'appId', 'type', 'otherData', 'accountType', 'userId', 'callerUin', 'callerVia', 'pushId', 'isCache', 'packageName', 'createVia', 'searchUid', 'expatiation', 'callerVersionCode', 'sourceSceneSlot', 'contentId', 'pushInfo', 'versionInfo', 'traceId', 'actionFlag', 'random', 'adv_source', 'adv_id', 'modleType', 'sourceModleType'],
            transferNameMap = {
                "recommendId": "otherData",
                "appid": "appId",
                "via": "callerVia",
                "sourceSceneSlotId": "sourceSceneSlot"
            }, slot;
        slot = this.formateSlotClient2Outside(data);
        params.slot = slot;
        for (var key in data) {
            if (data[key] == "") {
                continue;
            }
            if (transferNameMap.hasOwnProperty(key)) {
                params[transferNameMap[key]] = data[key];
            } else if (paramsName.indexOf(key) >= 0) {
                params[key] = data[key];;
            }
        }
        for (var key in params) {
            params[key] = "" + params[key];//所有的都转化为string
        }
        this.sendReportOutside(params);
    },
    formateSlot: function (column, index) {
        if (typeof column == "undefined") {
            return '';
        }
        if (typeof index == "undefined" || index === '') {
            return ('00' + column).slice(-2);
        }
        return [('00' + column).slice(-2), ('000' + index).slice(-3)].join('_');
    },
    formateSubPosition: function (index) {
        if (typeof index === 'undefined') {
            return '000';
        }
        return [('000' + index).slice(-3)].join('_');
    },
    pushRpData: function (opt) {
        var index = cache.length;
        cache.push(opt);
        return index;
    },
    getRpData: function (index) {
        return cache[index] || {}
    },
    getCache: function() {
        return cache;
    },
    clearCache: function() {
        cache = [];
    },
    addUrlWithReport: function (url, opt, extraData) {
        opt = opt || {}; url = url || ''; extraData = extraData || {};
        var reportConf = this.ReportConf || {};
        var prefix = opt.prefix || '', paramsDatas = [];
        paramsDatas.push(prefix + 'sourceScene=' + encodeURIComponent(reportConf.scene));
        paramsDatas.push(prefix + 'via=' + encodeURIComponent(reportConf.via));
        for (var key in extraData) {
            paramsDatas.push(key + '=' + encodeURIComponent(extraData[key]));
        }
        var hashIndex = url.lastIndexOf('#');
        if (hashIndex > -1) {
            var hash = url.substring(hashIndex),
                beforeUrl = url.substring(0, hashIndex);
            url = beforeUrl + ((beforeUrl.indexOf('?') > -1) ? '&' : '?') + (paramsDatas.join('&')) + hash;
        } else {
            url += ((url.indexOf('?') > -1) ? '&' : '?') + (paramsDatas.join('&'));
        }
        return url;
    },
    //***将应用端内上报的位置参数(slotId,status,subPosition)转化端外上报唯一的位置参数slot
    //slot(slotid_position_status_position2)
    //slotid:小场景，正常值补齐两位(1=>01)，空则为-1
    //position:大位置，正常值补齐三位(1=>001)，空则为-1
    //status:状态，正常值补齐两位(1=>01)，空则为-1
    //position2:小位置，正常值补齐两位(1=>01)，空则为-1
    formateSlotClient2Outside: function (data) {
        var slotid, position, status, position2;
        var clientSlotId = data.slotId || "", clientStatus = data.status, clientSubPosition = data.subPosition;
        var slotArr = [];
        if (clientSlotId && clientSlotId.indexOf('_') >= 0) {
            slotArr = clientSlotId.split('_');
        } else {
            slotArr.push(clientSlotId);
        }
        slotid = slotArr[0] ? (('00' + slotArr[0]).slice(-2)) : "-1";
        position = slotArr[1] ? (('000' + slotArr[1]).slice(-3)) : "-1";
        status = clientStatus ? (('00' + clientStatus).slice(-2)) : "-1";
        position2 = clientSubPosition ? (('00' + clientSubPosition).slice(-3)) : "-1";
        return ([slotid, position, status, position2]).join("_");
    },
    outsideReportPool: [],
    outsideReportTimer: null,
    sendReportOutside: function (reportParam) {
        var self = this;
        var reportUrl;
        if (document.domain.indexOf('0309') > -1) {
            reportUrl = '//webproxytest.sparta.html5.qq.com/H5StatUserAction';
        } else {
            reportUrl = 'https://pngweb.3g.qq.com/H5StatUserAction';
        }
        this.outsideReportPool.push(reportParam);
        if (!this.outsideReportTimer) {
            this.outsideReportTimer = setTimeout(function () {
                var subData = {
                    guid: "",
                    imei: "",
                    qua: "",
                    list: self.outsideReportPool
                };
                console.log("outsideReport" + JSON.stringify(subData));
                ping(reportUrl + '?buffer=' + encodeURIComponent(JSON.stringify(subData)));
                self.outsideReportPool = [];
                self.outsideReportTimer = null;
            }, 100);
        }
    }
};

module.exports = Report;